"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YOCTO_THRESHOLD_VARIATION = exports.FRACTIONAL_DIGITS = exports.FIGMENT_NEAR_VALIDATOR_ADDRESS = exports.STAKING_GAS_BASE = exports.MIN_ACCOUNT_BALANCE_BUFFER = exports.NEW_ACCOUNT_SIZE = exports.FALLBACK_STORAGE_AMOUNT_PER_BYTE = void 0;
exports.FALLBACK_STORAGE_AMOUNT_PER_BYTE = "10000000000000000000";
exports.NEW_ACCOUNT_SIZE = 182;
exports.MIN_ACCOUNT_BALANCE_BUFFER = "50000000000000000000000";
exports.STAKING_GAS_BASE = "25000000000000";
exports.FIGMENT_NEAR_VALIDATOR_ADDRESS = "ledgerbyfigment.poolv1.near";
exports.FRACTIONAL_DIGITS = 5;
exports.YOCTO_THRESHOLD_VARIATION = "10";
//# sourceMappingURL=constants.js.map